export default {
  allTractTypes: (state) => state.tractTypes
}
